import { apiClient } from '../../api/client';
import { ApiResponse } from '../../api/types';
import { RoomsConfig, RoomsConfigInput } from './types';

const URL = '/api/v1/admin/rooms-config';
export async function listRoomsConfigs(): Promise<RoomsConfig[]> {
  return (await apiClient.get<ApiResponse<RoomsConfig[]>>(URL)).data.data;
}
export async function saveRoomsConfig(input: RoomsConfigInput, id?: number): Promise<RoomsConfig> {
  const response = id
    ? await apiClient.put<ApiResponse<RoomsConfig>>(`${URL}/${id}`, input)
    : await apiClient.post<ApiResponse<RoomsConfig>>(URL, input);
  return response.data.data;
}
export async function deleteRoomsConfig(id: number): Promise<void> {
  await apiClient.delete(`${URL}/${id}`);
}

export async function invalidateRoomsConfigCache(): Promise<void> {
  await apiClient.post(`${URL}/invalidate-cache`);
}
